module.exports = __webpack_public_path__ + "static/media/img_dance04.1e782b98.png";